<template>
  <div class="publicSubmit">
    <app-header :disablejump="true"></app-header>
    <div class="appstoreWrap">
      <div class="storeHeader">
        <div class="logo">
          <div class="storeLogo">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAWCAYAAAB9oOpzAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAB90RVh0U29mdHdhcmUATWFjcm9tZWRpYSBGaXJld29ya3MgOLVo0ngAAAKCSURBVFiF1ZjNddpAEMd/+OkeThy4WBfOUQdZKog7MB0krgBSAXQQUoFNBYgKLFcQUUGUCpLDSm9nl0VaLQI//y9aSfOl2dn50Ggyna2BjGFRAE+BtCnwW9znwDxCpwL2HhkZsO4pq0hqRhVhSCgWwGPL+9S5V8ArULXwPKGdH4IxEd+X9GWIwD39DeuK4LFYL+trKp6l4vkOHUFd8qTOcjSZzjJH0RCoMDu6BFYDy59jPvZfB+0oQN4z8FCvC2A+mkxncaYNiz0mqlbAjx68lzrmOyYHVWinF7c4SintOaahaaACZErH+ZJsaPLPMEcORO66RcQoTLUYCr4okHpywirbKya3bBDOTNBV4z7SwHM4AtuBZcbiXLl2E26GcWyRoMNcDWxMznnH+HZS9lJb4Jfz/hG9gTEILdcWzS1yjIvc80z2LKWH5ssF+qozOl1YEZSgd6dhzDBlC/S5a2u0zuEYwXMtFITlG4XIhQl2yP8U65Lwtv4jIMVUxzfgBTu/HiSxPEpj7HO8vYJx74kM02iu0I5pAqHAccydWC8cQW4C/Oj4LNZv2L1T6RJLx3wT69xH3IE1+ozuia8g14QS6xK7VJ8MpI1jFLYHY6KlmdIVw/dFQyAV64LTCLLQOMZt2V+GtendMcY4Jq+v1jTtMtzhT7oxJfqauHT69zmh9Sg1I4FrxNIl7Kl8CIT+rlAe/bLbLYCv4l2JP4JSQUMCfHIUPWA3eTH4eyF/G7bOvW9AlXPPCv1rQeKPWJecbkJ1jZGgws5RoS25i6PDV6F7jU2sYUKGxIHTYrEbTaYzxWWziKukoH+OWmB3oHkP3q5jf8B8366+rsX9BvNfuqqfbf8DihKE/UEuTF4AAAAASUVORK5CYII="
            />
          </div>
          <div class="text">
            <p>rainbond工业互联网平台</p>
            <p>RainbondCloud</p>
          </div>
        </div>
        <div id="searchBox">
          <el-input placeholder="请输入关键字">
            <el-button slot="append" icon="el-icon-search">搜索</el-button>
          </el-input>
        </div>
      </div>

      <el-container style="margin-top:30px" >
        <el-aside
          class="leftBox"
        >
          <el-menu :default-openeds="['1', '3']" class="letMenu">
            <el-submenu index="1">
              <template slot="title"
                ><i class="el-icon-message"></i>导航一</template
              >
              <el-menu-item-group>
                <template slot="title"
                  >分组一</template
                >
                <el-menu-item index="1-1">选项1</el-menu-item>
                <el-menu-item index="1-2">选项2</el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group title="分组2">
                <el-menu-item index="1-3">选项3</el-menu-item>
              </el-menu-item-group>
              <el-submenu index="1-4">
                <template slot="title"
                  >选项4</template
                >
                <el-menu-item index="1-4-1">选项4-1</el-menu-item>
              </el-submenu>
            </el-submenu>
            <el-submenu index="2">
              <template slot="title"
                ><i class="el-icon-menu"></i>导航二</template
              >
              <el-menu-item-group>
                <template slot="title"
                  >分组一</template
                >
                <el-menu-item index="2-1">选项1</el-menu-item>
                <el-menu-item index="2-2">选项2</el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group title="分组2">
                <el-menu-item index="2-3">选项3</el-menu-item>
              </el-menu-item-group>
              <el-submenu index="2-4">
                <template slot="title"
                  >选项4</template
                >
                <el-menu-item index="2-4-1">选项4-1</el-menu-item>
              </el-submenu>
            </el-submenu>
            <el-submenu index="3">
              <template slot="title"
                ><i class="el-icon-setting"></i>导航三</template
              >
              <el-menu-item-group>
                <template slot="title"
                  >分组一</template
                >
                <el-menu-item index="3-1">选项1</el-menu-item>
                <el-menu-item index="3-2">选项2</el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group title="分组2">
                <el-menu-item index="3-3">选项3</el-menu-item>
              </el-menu-item-group>
              <el-submenu index="3-4">
                <template slot="title"
                  >选项4</template
                >
                <el-menu-item index="3-4-1">选项4-1</el-menu-item>
              </el-submenu>
            </el-submenu>
          </el-menu>
        </el-aside>

        <el-container style="margin-left:20px">
          <el-main>
            内容区
          </el-main>
        </el-container>
      </el-container>
    </div>
  </div>
</template>

<script>
import { isvalidUsername } from "@/utils/validate";
import { setSupport, SupportUrl } from "@/utils/support";

export default {
  name: "Login",
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/appStore.scss";
@import "src/styles/publicSubmit.scss";
</style>
<style rel="stylesheet/scss" lang="scss">
#searchBox .el-input-group > .el-input__inner {
  border: 1px solid #409eff !important;
}
#searchBox .el-input-group__append {
  width: 89px;
  color: #fff;
  background: #409eff;
}

#searchBox .el-icon-search {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/appstore/index.vue